import { ActivationFormState, ActivationStep } from '../types';

import { getLastActivationStep } from './validateActivationStep';

export const getNextActivationStep = (
  currentStep: ActivationStep,
  recipientType: ActivationFormState['recipientType']
): ActivationStep | null => {
  const lastStep = getLastActivationStep();
  if (currentStep >= lastStep) return null;

  if (currentStep === 1 && recipientType === 'corporation') {
    return 3;
  }
  if (currentStep === 2 && recipientType !== 'corporation') {
    return 4;
  }

  return (currentStep + 1) as ActivationStep;
};

export const getPreviousActivationStep = (
  currentStep: ActivationStep,
  recipientType: ActivationFormState['recipientType']
): ActivationStep | null => {
  if (currentStep <= 1) return null;

  if (currentStep === 3 && recipientType === 'corporation') {
    return 1;
  }
  if (currentStep === 4 && recipientType !== 'corporation') {
    return 2;
  }

  return (currentStep - 1) as ActivationStep;
};
